import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import 'vue-progress-path/dist/vue-progress-path.css';
import VueProgress from 'vue-progress-path';
import App from './App';

import store from './store';

import './plugins/format';
import apolloProvider from './plugins/apollo';

import './assets/styles/main.scss';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueProgress);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_PATH || '/',
  routes: [],
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  store,
  router,
  apolloProvider,
});



// WEBPACK FOOTER //
// ./src/main.js